import { type ReactNode, useMemo } from 'react'
import { RowContainerWithScroll } from '@/components/RowContainerWithScroll'
import { Box } from '@sevenrooms/ui-kit/layout'
import { LinkButton } from '../../LinkButton/LinkButton'
import { ReservationTimeslots } from '../ReservationTimeslots'
import type { ReservationTimeSlotVariant } from '../../../../../components/ReservationTimeslot'
import type { AvailabilityTimeWithUpSellCost } from '../../../../../hooks'

const timeslotShortVariantWidth = '113px'

interface RowTimeSlotsProps {
  timeslots?: AvailabilityTimeWithUpSellCost[]
  timeSlotVariant?: ReservationTimeSlotVariant
  onTimeSlotClick?: (slot: AvailabilityTimeWithUpSellCost) => void
  onDateLabelClick?: () => void
  requestOrPriorityAlertAvailability?: ReactNode
  startDate?: string
  descriptionType?: 'short' | 'full'
  currencyCode: string
}

export function RowTimeSlots({
  timeslots,
  timeSlotVariant = 'primary',
  descriptionType = 'full',
  onTimeSlotClick,
  onDateLabelClick,
  startDate,
  requestOrPriorityAlertAvailability,
  currencyCode,
}: RowTimeSlotsProps) {
  const timeslotWidth = useMemo(() => {
    const buttonsCount = timeslots?.length || 0 + (requestOrPriorityAlertAvailability ? 1 : 0)
    if (buttonsCount < 4) {
      return '100%'
    }
    return timeslotShortVariantWidth
  }, [requestOrPriorityAlertAvailability, timeslots?.length])

  return (
    <RowContainerWithScroll
      data-test="sr-room-card-availability-container"
      spacing="sm"
      childWidth={timeslotWidth}
      label={startDate ? <LinkButton text={startDate} onClick={onDateLabelClick} data-test="sr-room-card-date-label-button" /> : undefined}
    >
      <ReservationTimeslots
        timeslotWidth={timeslotWidth}
        currencyCode={currencyCode}
        timeslots={timeslots}
        onTimeSlotClick={onTimeSlotClick}
        timeSlotVariant={timeSlotVariant}
        descriptionType={descriptionType}
      />
      {requestOrPriorityAlertAvailability && <Box minWidth={timeslotWidth}>{requestOrPriorityAlertAvailability}</Box>}
    </RowContainerWithScroll>
  )
}
